"use strict";

exports.__esModule = true;
var _AlertTagsInput = require("./AlertTagsInput");
Object.keys(_AlertTagsInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AlertTagsInput[key]) return;
  exports[key] = _AlertTagsInput[key];
});